/**
 * Marquee
 */

// Vendors
import $ from 'jquery';
import { debounce } from 'lodash';

// Components
import carousel from '../framework/carousel';

// Utilities
import { scrollToElement } from '../lib/utilities';

// Trigger marquee init.
$(document).ready(() => {
  $('.marquee').addClass('marquee--initialized');

  if ($('.marquee__slide--initial').length) {
    $('.marquee__slide--initial')
      .addClass('marquee__slide--active')
      .removeClass('marquee__slide--initial');
  } else {
    $(`[data-marquee-slide="0"]`).addClass('marquee__slide--active');
  }
});

// Smooth scroll to anchors
$(document).on('click', '.marquee__text-body a[href^="#"]', (event) => {
  event.preventDefault();
  const target = $(event.currentTarget).attr('href');
  if (target.length > 1 && $(target).length > 0) {
    scrollToElement($(target));
  }
});

$('[data-product-gallery-carousel]').each((index, element) => {
  const galleryId = $(element).data('product-gallery-carousel');

  const productCarousel = carousel(element, {
    arrows: false,
    autoplay: false,
    cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
    dots: false,
    draggable: false,
    infinite: true,
    speed: 500
  });

  const productNav = carousel(
    `[data-product-gallery-carousel-nav="${galleryId}"]`,
    {
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      infinite: false,
      dots: false,
      speed: 500,
      focusOnSelect: true,
      cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
      asNavFor: `[data-product-gallery-carousel="${galleryId}"]`,
      prevArrow:
        '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-up"></span></button>',
      nextArrow:
        '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-down"></span></button>',
      vertical: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            prevArrow:
              '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-left"></span></button>',
            nextArrow:
              '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-right"></span></button>',
            vertical: false
          }
        },
        {
          breakpoint: 892,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            prevArrow:
              '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-left"></span></button>',
            nextArrow:
              '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-right"></span></button>',
            vertical: false
          }
        },
        {
          breakpoint: 792,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow:
              '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-left"></span></button>',
            nextArrow:
              '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-right"></span></button>',
            vertical: false
          }
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow:
              '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-left"></span></button>',
            nextArrow:
              '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-right"></span></button>',
            vertical: false
          }
        },
        {
          breakpoint: 420,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow:
              '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-left"></span></button>',
            nextArrow:
              '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-right"></span></button>',
            vertical: false
          }
        }
      ]
    }
  );
});
